import { Grid } from '@mui/material';
import UserAvatar from '../UserAvatar/UserAvatar';
import styles from './styles';
import { HeaderProps } from './types';

const Header = ({ titleComponent, name, profileImg, setOpenProfileDetails, openProfileDetails }: HeaderProps) => {
    return (
        <Grid container sx={styles.container}>
            <Grid data-testid="header-title" item xs={6} md={6} sm={6}>
                {titleComponent}
            </Grid>
            <Grid
                data-testid="profile_img"
                id="profile_img"
                sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                onClick={() => setOpenProfileDetails(!openProfileDetails)}
            >
                <UserAvatar
                    id="dashbord_user_icon"
                    name={`${name}`}
                    source={profileImg && profileImg !== 'null' && profileImg !== 'undefined' ? profileImg : ''}
                    size={40}
                    radius="20px"
                />
            </Grid>
        </Grid>
    );
};

export default Header;
